import { KNOWN_DIRECTIVE_NAMES } from './remarkAiDirectives';

// A directive at the very end of the text: `:doc`, `:documentation`,
// `::documentation{id=abc` — anything short of the closing brace. A completed
// `{id=abc}` cannot match: the attribute group may not span a `}`, and without
// it the name would have to sit at the end of the string.
const TRAILING_DIRECTIVE_RE = /:{1,2}([a-z][a-z0-9-]*)(\{[^}]*)?$/i;

// Drop a directive the stream has only partly delivered.
//
// The BE streams an answer as token deltas, so `:documentation{id=…}` arrives
// across several frames and the text is briefly not valid directive syntax.
// remark-directive still parses the leading `:documentation` — a name with no
// attributes is a legal directive — which remarkAiDirectives then skips for
// having no id, leaving the half-streamed `{id=abc` behind as literal text. The
// reader sees that raw fragment flash before the chip resolves.
//
// Only the tail is ever affected: the streamed text is a contiguous prefix (see
// getAiStreamText), so an incomplete directive can only sit at the end. Hiding
// it costs nothing — the next delta re-renders it complete, as a chip.
export default function maskIncompleteDirective(text: string): string {
  const match = TRAILING_DIRECTIVE_RE.exec(text);
  if (!match) return text;
  const name = match[1].toLowerCase();
  const hasOpenAttributes = match[2] !== undefined;
  // With attributes open the name is settled, so it has to be one we render.
  // Otherwise the name itself is still streaming — hide it only while it could
  // still grow into a known one, so ordinary prose ("ratio:approx") is left be.
  const isDirective = hasOpenAttributes
    ? KNOWN_DIRECTIVE_NAMES.includes(name)
    : KNOWN_DIRECTIVE_NAMES.some((known) => known.startsWith(name));
  return isDirective ? text.slice(0, match.index) : text;
}
